module.exports = __webpack_public_path__ + "img/7.15527543.svg";